import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { Button } from '../ui/button'
import React, { useState } from 'react'
import useAppStore from '@/store/useAppStore'
import { useForm } from 'react-hook-form'
import { TextField } from '../ui/TextField'
import { Separator } from '../ui/separator'
import useCreateModel from '@/services/api/model/useCreateModel'
import useOpenModalWindow from '../../hooks/useOpenModalWndow'

interface ModelValues {
  name: string
  description?: string
}

export default function CreateModel({
  open,
  setOpen,
  onSuccess,
}: {
  open?: boolean
  setOpen?: (state: boolean) => void
  onSuccess?: (response: {}) => void
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ModelValues>()
  const [isFocusedName, setIsFocusedName] = useState(false)
  const [isFocusedDescription, setIsFocusedNameDescription] = useState(false)
  const { createModel } = useCreateModel()
  const { closeModal } = useOpenModalWindow()

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  React.useEffect(() => {
    setValue('name', name)
  }, [name])

  const handleNameChange = (event) => {
    const value = event.target.value
    if (value.length <= 30) {
      setName(value)
    }
  }

  React.useEffect(() => {
    setValue('description', description)
  }, [description])

  const handleDescriptionChange = (event) => {
    const value = event.target.value
    if (value.length <= 40) {
      setDescription(value)
    }
  }

  const onSubmit = async (data) => {
    const response = await createModel(data)
    if (onSuccess) onSuccess(response.data)
    if (setOpen) setOpen(false)
    closeModal()
  }

  return (
    <form
      noValidate
      // className=" flex flex-col"
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit(onSubmit)
      }}
    >
      <Dialog open={open}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create Model</DialogTitle>
            <DialogClose>
              <XMarkIcon
                onClick={() => {
                  if (setOpen) setOpen(false)
                }}
              />
            </DialogClose>
          </DialogHeader>
          <Separator />
          <DialogBody>
            <div className="mb-3">
              <TextField
                status={errors?.name ? 'error' : null}
                statusText={errors.name?.message}
              >
                <TextField.Label className="flex justify-between text-sm">
                  Model Name
                  <span
                    className={`text-txt-secondary ${isFocusedName ? '' : 'hidden'}`}
                  >
                    {name.length}/30
                  </span>
                </TextField.Label>
                <TextField.Input
                  maxLength={30}
                  placeholder="e.g., Mortgage"
                  {...register('name', {
                    required: 'Please fill out this field',
                    value: name,
                    onChange: handleNameChange,
                  })}
                  onFocus={() => setIsFocusedName(true)}
                  onBlur={() => setIsFocusedName(false)}
                />
              </TextField>
            </div>

            <div className="mb-4">
              <TextField>
                <TextField.Label className="flex  justify-between text-sm">
                  Description
                  <span
                    className={`text-txt-secondary ${isFocusedDescription ? '' : 'hidden'}`}
                  >
                    {description.length}/40
                  </span>
                </TextField.Label>
                <TextField.Input
                  maxLength={40}
                  placeholder="e.g., Main Account"
                  {...register('description', {
                    value: description,
                    onChange: handleDescriptionChange,
                  })}
                  onFocus={() => setIsFocusedNameDescription(true)}
                  onBlur={() => setIsFocusedNameDescription(false)}
                />
              </TextField>
            </div>
          </DialogBody>
          <Separator />
          <DialogFooter>
            <div>
              <DialogClose asChild>
                <Button
                  onClick={() => {
                    if (setOpen) setOpen(false)
                  }}
                  variant="secondary"
                  className="mr-2"
                >
                  Cancel
                </Button>
              </DialogClose>
              <Button type="submit" onClick={handleSubmit(onSubmit)}>
                Create
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </form>
  )
}
